

























import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  applist: any[] = [];

  dispatchType: string = "apprelease/statistics";

  columns: any[] = [
    { title: "应用", scopedSlots: { customRender: "service" } },
    { title: "系统", dataIndex: "system_name" },
    { title: "版本", dataIndex: "app_version" },
    { title: "用户数", dataIndex: "ccount" }
  ];

  async loadAppList() {
    const res = await this.$store.dispatch("api/getApplist", {});
    if (res && res.Data && res.Data !== "{}") {
      this.applist = res.Data;
    }
  }

  mounted() {
    this.loadAppList();
    this.loadData();
  }
}
